module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrights"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2004 The Johns Hopkins University Press"), _c('br'), _vm._v("All rights reserved. Published 2004"), _c('br'), _vm._v("Printed in the United States of America on acid-free paper"), _c('br'), _vm._v("9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyrights"
  }, [_vm._v("Some of the profiles, in slightly different form, were published in "), _c('em', [_vm._v("Civil War News")]), _vm._v(" between April 2001 and June 2003. An earlier version of the profile of James M. Cooper was published in the September-October 2001 issue of "), _c('em', [_vm._v("Military Images")]), _vm._v(" magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrights"
  }, [_vm._v("The Johns Hopkins University Press"), _c('br'), _vm._v("2715 North Charles Street"), _c('br'), _vm._v("Baltimore, Maryland 21218–4363"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyrights"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Coddington, Ron, 1963-")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Faces of the Civil War: an album of Union soldiers and their stories / Ronald S. Coddington; with a foreword by Michael Fellman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("        p. cm."), _c('br'), _vm._v("Includes bibliographical references (p.) and index.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 0–8018-7876–4 (alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("1. United States — History—Civil War, 1861–1865 — Biography. 2. United States — History—Civil War, 1861–1865 — Portraits. 3. United States. Army— Officers — Biography. 4. United States. Army—Officers — Portraits. 5. Soldiers — United States — Biography. 6. Soldiers—United States — Portraits. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("467.C63 2004")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("973.7′41′0922 — dc22")]), _vm._v(" "), _c('p', {
    staticClass: "attributions"
  }, [_vm._v("2003018305")]), _vm._v(" "), _c('p', {
    staticClass: "copyrights"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrights"
  }, [_c('em', [_vm._v("The frontispiece photograph was taken by James Presley Ball (1825–1904) between 1861 and 1863. The unidentified corporal’s firearm is an Austrian Lorenz musket.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32210b77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04.vue
// module id = 69
// module chunks = 0